import React from 'react';
import styled from 'styled-components';
import { Button } from '@cityelectricalfactors/ui-components';

const ApprovalsGroupUser = ({ title, user, openMessageModal }) => {
  const {
    forename,
    surname,
    email,
    credit_limit: creditLimit,
    max_approval_limit: maxApprovalLimit,
  } = user;

  const limitTypes = {
    'Group Administrators': 'No Limit',
    Approvers: `£${maxApprovalLimit}`,
    'Standard Users': `£${creditLimit}`,
  };
  const limitType = limitTypes[title];

  return (
    <li className="create-group-user fl jc-sb ptb-12 pl-12 pr-14">
      <div>
        <h4
          data-testid="user-name"
          className="ff-r fw-700 fs-14 tc-grey-70 lh-1-1 mb-0">
          {`${forename} ${surname}`}
        </h4>
        <p className="ff-r fs-14 tc-grey-50 lh-1-1 mb-0">{email}</p>
      </div>
      <div className="create-group-user__wrapper fl jc-sb">
        <p className="ff-r fw-700 fs-14 tc-grey-70 lh-1 mb-0 js-fe mr-90">
          {limitType}
        </p>
        <RemoveBtn
          handleClick={() => openMessageModal(user, title)}
          className="bg-transparent tc-cef-red as-c fw-500 p-0">
          Remove
        </RemoveBtn>
      </div>
    </li>
  );
};

const RemoveBtn = styled(Button)`
  min-height: 0;
`;

export default ApprovalsGroupUser;
